import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Divider = ({ className, children, hrClassName }) => (
  <div className={classNames('w-100 position-relative text-center', className)}>
    <hr className={classNames('text-300', hrClassName)} />
    <div className="divider-content-center">{children}</div>
  </div>
);

Divider.propTypes = {
  className: PropTypes.node,
  children: PropTypes.node
};

export default Divider;
